export default __webpack_public_path__ + "static/Dragon_website_animation_loop-76e1acc5a48bd3b7b62f3710338bcd36.mp4";